var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark",class:{'mark__small': _vm.small},style:(`color: ${_vm.color}`)},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }